// extracted by mini-css-extract-plugin
export default {"font_family_container":"FontFamilyConfiguration_font_family_container__cx-Hx","font_family_select":"FontFamilyConfiguration_font_family_select__N3uC-"};